export default __webpack_public_path__ + "static/SabrinaM-7829a0a2c2dae24295735b9abb92330e.png";